import React from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import roundClearAll from "@iconify/icons-ic/round-clear-all";
import { get_root_value } from "src/utils/domUtils";
import { Icon } from "@iconify/react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/lab";

export default function VideoFilter({
  filterData,
  handleSelectOther,
  searchFunction,
  handleClearFilter,
}) {
  return (
    <>
      <div className="container new-memories px-4">
        <div className="col-12 mt-3">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Start Date *"
              name="start"
              inputFormat="dd-MM-yyyy"
              value={filterData.start}
              onChange={(e) => {
                handleSelectOther("start", e);
              }}
              required
              format="DD-MM-YYYY"
              renderInput={(params) => (
                <TextField {...params} className="inputs-fields" fullWidth />
              )}
            />
          </LocalizationProvider>
        </div>
        <div className="col-12 mt-3">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="End Date *"
              name="end"
              value={filterData.end}
              inputFormat="dd-MM-yyyy"
              required
              onChange={(e) => {
                handleSelectOther("end", e);
              }}
              format="DD-MM-YYYY"
              renderInput={(params) => (
                <TextField {...params} className="inputs-fields" fullWidth />
              )}
            />
          </LocalizationProvider>
        </div>
        <>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterData.filter_by_dates}
                onChange={(e) => {
                  handleSelectOther("filter_by_dates", e.target.checked);
                }}
              />
            }
            label="Comparison Against Selected Date Range"
          />
          {filterData.filter_by_dates && (
            <>
              <div className="col-12 mt-3">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="Start Date *"
                    name="comp_start_date"
                    inputFormat="dd-MM-yyyy"
                    value={filterData.comp_start_date}
                    onChange={(e) => {
                      handleSelectOther("comp_start_date", e);
                    }}
                    required
                    format="DD-MM-YYYY"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="inputs-fields"
                        fullWidth
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
              <div className="col-12 mt-3">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="End Date *"
                    name="comp_end_date"
                    value={filterData.comp_end_date}
                    inputFormat="dd-MM-yyyy"
                    required
                    onChange={(e) => {
                      handleSelectOther("comp_end_date", e);
                    }}
                    format="DD-MM-YYYY"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        className="inputs-fields"
                        fullWidth
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </>
          )}
        </>
        <Box sx={{ py: 2 }}>
          <Button
            fullWidth
            size="large"
            type="submit"
            color="inherit"
            variant="outlined"
            onClick={searchFunction}
            startIcon={
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: 5 }}
              >
                <path
                  d="M13.1165 0.25H0.883548C0.321452 0.25 0.0378205 0.932013 0.436097 1.33029L5.3125 6.20743V11.6406C5.3125 11.8471 5.41325 12.0406 5.58242 12.1591L7.69179 13.6351C8.10794 13.9264 8.6875 13.6312 8.6875 13.1167V6.20743L13.564 1.33029C13.9615 0.932804 13.6798 0.25 13.1165 0.25Z"
                  fill={get_root_value("--portal-theme-primary")}
                />
              </svg>
            }
          >
            Filter
          </Button>
        </Box>
        <Button
          fullWidth
          size="large"
          type="submit"
          color="inherit"
          variant="outlined"
          className="mb-3"
          onClick={handleClearFilter}
          startIcon={<Icon icon={roundClearAll} />}
        >
          Clear All
        </Button>
      </div>
    </>
  );
}
